
import { Action, Toast, ToasterToast } from "./types"
import { reducer, listeners, getState, setState } from "./toast-reducer"
import { genId } from "./toast-utils"

// Central dispatch function
export function dispatch(action: Action) {
  const currentState = getState()
  const newState = reducer(currentState, action)
  setState(newState)
  
  listeners.forEach((listener) => {
    listener(newState)
  })
}

// Toast creation function
export function toast({ ...props }: Toast) {
  const id = genId()

  const update = (props: ToasterToast) =>
    dispatch({
      type: "UPDATE_TOAST",
      toast: { ...props, id },
    })
  const dismiss = () => dispatch({ type: "DISMISS_TOAST", toastId: id })

  dispatch({
    type: "ADD_TOAST",
    toast: {
      ...props,
      id,
      open: true,
      onOpenChange: (open) => {
        if (!open) dismiss()
      },
    },
  })

  return {
    id: id,
    dismiss,
    update,
  }
}
